import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

import Route from './Route';

import Login from '../pages/Public/Login';
import Welcome from '../pages/Welcome';
import PatientWelcome from '../pages/Patient/Welcome';
import PatientWhatsappLink from '../pages/Patient/WhatsappLink';
import Error404 from '../pages/Public/Error404';
import VideoRoom from '../pages/Public/VideoRoom';
import PatientProfile from '../pages/Patient/Profile';
import UserProfile from '../pages/User/Profile';
import ResetPassword from '../pages/User/ResetPassword';
import ForgotPassword from '../pages/User/ForgotPassword';
import UserEdit from '../pages/User/Edit';
import UserList from '../pages/User/List';
import ProfileList from '../pages/Profile/List';
import ProfileUserItem from '../pages/Profile/Item/UserItemProfile';
import PatientRegister from '../pages/Patient/Register';
import PatientEdit from '../pages/Patient/Edit';
import DashboardNotification from '../pages/Dashboard/Notification';
import ListPatients from '../pages/Patient/List';
import DashboardProfessional from '../pages/Professional/Dashboard';
import Attendance from '../pages/Patient/Attendance';
import AppointmentsList from '../pages/Appointments/List';
import SheetAnswersList from '../pages/Sheet/AnswersList';
import SheetPendenciesList from '../pages/Sheet/PendenciesList';
// import SignatureList from '../pages/Signature/List';
// import SignatureProfile from '../pages/Signature/Profile';
import AttendanceReports from '../pages/Reports/Attendance/List';
import InstitutionList from '../pages/Institution/List';
import InstitutionEdit from '../pages/Institution/Edit';
import AlertsList from '../pages/Alerts/List';
import { WellFare } from '../pages/Administration/WellFare';
import { DataList } from '../pages/Data/List';

const Routes: React.FC = () => (
  <Switch>
    <Redirect from="/" to="/login" exact />
    <Route path="/login" exact component={Login} />
    <Route path="/welcome" exact component={Welcome} />
    {/*
      Ativação da conta do paciente (0.33), pública: quem chega aqui é o titular, pelo link
      do e-mail de boas-vindas, e ele ainda não tem sessão — é a senha dele que está sendo
      criada. A `/welcome` acima é a do usuário de equipe, e as duas telas são diferentes de
      propósito (ver o comentário da página).
    */}
    <Route path="/patient/welcome" exact component={PatientWelcome} />
    {/*
      Retentativa do vínculo de WhatsApp (0.35), para quem pulou o passo na ativação.
      Pública e **sem token na URL no primeiro passo**: quem chega informa o e-mail e
      recebe um link. É por isso que a equipe pode simplesmente passar este endereço a
      quem precisar — não há nada a gerar antes.
    */}
    <Route path="/patient/whatsapp" exact component={PatientWhatsappLink} />
    <Route path="/password/reset" exact component={ResetPassword} />
    <Route path="/password/forgot" exact component={ForgotPassword} />
    <Route path="/video" exact component={VideoRoom} />
    {/* <Route path="/dashboard" exact component={DashboardMain} /> */}
    <Route
      path="/dashboard/profile"
      exact
      component={DashboardProfessional}
      isPrivate
    />
    <Route
      path="/patient/profile"
      exact
      component={PatientProfile}
      isPrivate
      permission="patient_profile"
    />
    <Route
      path="/patient/register"
      exact
      component={PatientRegister}
      isPrivate
      permission="register_patient"
    />
    <Route
      path="/patient/list"
      exact
      component={ListPatients}
      isPrivate
      permission="list_of_patients"
    />
    <Route path="/patient/attendance" exact component={Attendance} isPrivate />
    <Route
      path="/patient/register/complete"
      exact
      component={PatientEdit}
      isPrivate
      permission="register_patient"
    />
    <Route
      path="/patient/edit"
      exact
      component={PatientEdit}
      isPrivate
      permission="edit_patient"
    />
    <Route
      path="/user/profile"
      exact
      component={UserProfile}
      isPrivate
      permission="user_profile"
    />
    <Route
      path="/user/register"
      exact
      component={UserEdit}
      isPrivate
      permission="register_user"
    />
    <Route path="/user/edit" exact component={UserEdit} isPrivate />
    <Route
      path="/user/list"
      exact
      component={UserList}
      isPrivate
      permission="list_of_users"
    />
    <Route
      path="/profile/list"
      exact
      component={ProfileList}
      isPrivate
      permission="list_profiles"
    />
    <Route
      path="/profile/:id"
      exact
      component={ProfileUserItem}
      isPrivate
      permission="list_profile_users"
    />
    <Route
      path="/appointments/list"
      exact
      component={AppointmentsList}
      isPrivate
      permission="list_of_appointments"
    />
    <Route
      path="/data/list"
      exact
      component={DataList}
      isPrivate
      permission="list_health_sheets"
    />
    <Route
      path="/sheet/answers"
      exact
      component={SheetAnswersList}
      isPrivate
      permission="list_health_sheets"
    />
    <Route
      path="/sheet/pendencies"
      exact
      component={SheetPendenciesList}
      isPrivate
      permission="list_health_sheets"
    />

    <Route
      path="/institution/list"
      exact
      component={InstitutionList}
      isPrivate
      permission="list_institutions"
    />

    {/*
      `register_institution` e do `administrator` apenas, e e o que
      `POST /institutions` exige. Sem o gate na rota, qualquer autenticado abria a
      tela de cadastro e so descobria a negativa no 403 do submit.
    */}
    <Route
      path="/institution/register"
      exact
      component={InstitutionEdit}
      isPrivate
      permission="register_institution"
    />
    {/*
      A tela de edição existia desde sempre (o componente detecta o modo por
      `pathname.includes('edit')`) e **não tinha rota**, porque o back não tinha
      `PUT /institutions/{id}` — instituição era write-once. As duas pontas nasceram
      na tarefa 0.13 do roadmap B2G. Continua fora do menu, como o resto da área de
      instituições, até a F8.1.
    */}
    <Route
      path="/institution/edit/:id"
      exact
      component={InstitutionEdit}
      isPrivate
      permission="edit_institution"
    />
    {/*     <Route
      path="/signature/list"
      exact
      component={SignatureList}
      isPrivate
      permission="list_signatures"
    /> */}
    {/*     <Route
      path="/signature/profile"
      exact
      component={SignatureProfile}
      isPrivate
      permission="view_signature"
    /> */}
    <Route
      path="/reports/attendance/list"
      exact
      component={AttendanceReports}
      isPrivate
      permission="attendance_report"
    />
    <Route
      path="/dashboard/notifications"
      exact
      component={DashboardNotification}
      isPrivate
    />
    {/*
      A home de Alertas (tarefa 8.3). Substitui `/dashboard/notices`, que era o
      painel de dez/2021 -- deslinkado do menu desde fev/2024 e alimentado por um
      agregado que devolvia zero para todo mundo, porque o ponteiro de aviso do
      paciente e sempre nulo desde a 0.20.

      A chave e `list_alerts`, nova: `view_notices_dashboard` saiu do `cinco-back`
      junto com o painel antigo, na 4.9.
    */}
    <Route
      path="/alerts"
      exact
      component={AlertsList}
      isPrivate
      permission="list_alerts"
    />
    {/*
      O antigo painel de contingencia (8.4, `/alerts/simple`). Foi absorvido pela
      home em 2026-09-24: era uma projecao da mesma fila (`origin=relogio`), e duas
      telas com os mesmos alertas confundiam o profissional. O redirect preserva
      links salvos. Sem `?origin=`: o filtro de origem saiu em 2026-09-25, porque
      nenhum escritor manda `source` ainda (tarefa 2.2).
    */}
    <Redirect from="/alerts/simple" to="/alerts" exact />
    {/* <Route
      path="/administration/sheetFormIo"
      exact
      component={CreateSheetFormIo}
    /> */}
    {/* <Route path="/administration/sheet" exact component={SheetInit} /> */}
    <Route
      path="/administration/well_fare"
      exact
      component={WellFare}
      permission="list_health_sheets"
      isPrivate
    />
    <Route path="*" component={Error404} />
  </Switch>
);

export default Routes;
